import * as GL from './webgl2constants'

export function isInt(type: GLenum) {
	switch (type) {
		case GL.BYTE:
		case GL.SHORT:
		case GL.INT:
		// case GL.INT64 // mentionned in https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Types
		case GL.UNSIGNED_BYTE:
		case GL.UNSIGNED_SHORT:
		case GL.UNSIGNED_INT:
			return true

		case GL.HALF_FLOAT:
		case GL.FLOAT:
			return false

		case GL.INT:
		case GL.INT_VEC2:
		case GL.INT_VEC3:
		case GL.INT_VEC4:
		case GL.UNSIGNED_INT:
		case GL.UNSIGNED_INT_VEC2:
		case GL.UNSIGNED_INT_VEC3:
		case GL.UNSIGNED_INT_VEC4:
			return true

		case GL.BOOL:
		case GL.BOOL_VEC2:
		case GL.BOOL_VEC3:
		case GL.BOOL_VEC4:
		case GL.FLOAT:
		case GL.FLOAT_VEC2:
		case GL.FLOAT_VEC3:
		case GL.FLOAT_VEC4:
		case GL.FLOAT_MAT2:
		case GL.FLOAT_MAT3:
		case GL.FLOAT_MAT4:
		case GL.FLOAT_MAT2x3:
		case GL.FLOAT_MAT2x4:
		case GL.FLOAT_MAT3x2:
		case GL.FLOAT_MAT3x4:
		case GL.FLOAT_MAT4x2:
		case GL.FLOAT_MAT4x3:
			return false

		// TODO
		case GL.SAMPLER_2D:
		case GL.SAMPLER_3D:
		case GL.SAMPLER_CUBE:
		case GL.SAMPLER_CUBE_SHADOW:
		case GL.SAMPLER_2D_SHADOW:
		case GL.SAMPLER_2D_ARRAY:
		case GL.SAMPLER_2D_ARRAY_SHADOW:
		case GL.INT_SAMPLER_2D:
		case GL.INT_SAMPLER_3D:
		case GL.INT_SAMPLER_CUBE:
		case GL.INT_SAMPLER_2D_ARRAY:
		case GL.UNSIGNED_INT_SAMPLER_2D:
		case GL.UNSIGNED_INT_SAMPLER_3D:
		case GL.UNSIGNED_INT_SAMPLER_CUBE:
		case GL.UNSIGNED_INT_SAMPLER_2D_ARRAY:
			return true
	}
	throw `${arguments.callee.name} error : ${type} not supported`
}

export function gltype2dim(type: GLenum): GLint {
	switch (type) {
		case GL.FLOAT: return 1
		case GL.FLOAT_VEC2: return 2
		case GL.FLOAT_VEC3: return 3
		case GL.FLOAT_VEC4: return 4

		case GL.INT: return 1
		case GL.INT_VEC2: return 2
		case GL.INT_VEC3: return 3
		case GL.INT_VEC4: return 4

		case GL.UNSIGNED_INT: return 1
		case GL.UNSIGNED_INT_VEC2: return 2
		case GL.UNSIGNED_INT_VEC3: return 3
		case GL.UNSIGNED_INT_VEC4: return 4

		case GL.BOOL: return 1
		case GL.BOOL_VEC2: return 2
		case GL.BOOL_VEC3: return 3
		case GL.BOOL_VEC4: return 4

		case GL.FLOAT_MAT2: return 2 * 2
		case GL.FLOAT_MAT3: return 3 * 3
		case GL.FLOAT_MAT4: return 4 * 4

		case GL.FLOAT_MAT2x3: return 2 * 3
		case GL.FLOAT_MAT2x4: return 2 * 4
		case GL.FLOAT_MAT3x2: return 3 * 2
		case GL.FLOAT_MAT3x4: return 3 * 4
		case GL.FLOAT_MAT4x2: return 4 * 2
		case GL.FLOAT_MAT4x3: return 4 * 3

		case GL.SAMPLER_2D:
		case GL.SAMPLER_3D:
		case GL.SAMPLER_CUBE:
		case GL.SAMPLER_CUBE_SHADOW:
		case GL.SAMPLER_2D_SHADOW:
		case GL.SAMPLER_2D_ARRAY:
		case GL.SAMPLER_2D_ARRAY_SHADOW:
		case GL.INT_SAMPLER_2D:
		case GL.INT_SAMPLER_3D:
		case GL.INT_SAMPLER_CUBE:
		case GL.INT_SAMPLER_2D_ARRAY:
		case GL.UNSIGNED_INT_SAMPLER_2D:
		case GL.UNSIGNED_INT_SAMPLER_3D:
		case GL.UNSIGNED_INT_SAMPLER_CUBE:
		case GL.UNSIGNED_INT_SAMPLER_2D_ARRAY:
			return 1
	}
	throw `${arguments.callee.name} error : ${type} not supported`
}

export function arrayBufferView2glType(pixels: ArrayBufferView): GLenum {
	if (pixels instanceof Float32Array) return GL.FLOAT
	if (pixels instanceof Int8Array) return GL.BYTE
	if (pixels instanceof Int16Array) return GL.SHORT
	if (pixels instanceof Int32Array) return GL.INT
	if (pixels instanceof Uint8ClampedArray) return GL.UNSIGNED_BYTE
	if (pixels instanceof Uint8Array) return GL.UNSIGNED_BYTE
	if (pixels instanceof Uint16Array) {
		// return GL.HALF_FLOAT ; floatMode = true
		return GL.UNSIGNED_SHORT // let's assume it's always this for now
		// return GL.UNSIGNED_SHORT_4_4_4_4
		// return GL.UNSIGNED_SHORT_5_5_5_1
		// return GL.UNSIGNED_SHORT_5_6_5
	}
	if (pixels instanceof Uint32Array) {
		return GL.UNSIGNED_INT // let's assume it's always this for now
		// return GL.UNSIGNED_INT_10F_11F_11F_REV
		// return GL.UNSIGNED_INT_2_10_10_10_REV
		// return GL.UNSIGNED_INT_24_8
		// return GL.UNSIGNED_INT_5_9_9_9_REV
	}
	throw "unsupported"
}

